// @flow

import React from 'react';

import Link from 'app/common/components/Link';
import { buildFromToLink } from 'app/zap-mover/Selectors';

type ZapDisabledByTeamsForMemberProps = {
  accountId: number,
};

export const ZapDisabledByTeamsForMember = ({
  accountId,
}: ZapDisabledByTeamsForMemberProps) => (
  <div>
    <p>
      <strong>Need to run this Zap?</strong>
    </p>
    <p>
      Need to run this Zap?{' '}
      <Link href={buildFromToLink(accountId)}>
        Move it to your Personal Account.
      </Link>
    </p>
  </div>
);

export const SharedZapDisabledByTeamsForOwner = () => (
  <div>
    <p>
      <strong>Need to run this Zap?</strong>
    </p>
    <p>
      Move it to a Private Folder <br />
      or <Link href="/app/billing/plans">upgrade to a Team plan</Link>.
    </p>
  </div>
);
